module.exports = __webpack_public_path__ + "img/wsm.405a2c5f.svg";